import React from "react";
import BalanceStatus from "../components/BalanceStatus";
import Form from "../components/Form";
import Transactions from "../components/Transactions/Transactions";

const Home = () => {
    return (
        <>
            <BalanceStatus />
            <Form />
            <Transactions />
        </>
    );
};

export default Home;
